module.exports = __webpack_public_path__ + "img/validation-icon-old.baceb384.svg";